import type { CbiFrontendServiceContext } from "../../frontend/context/CbiFrontendServiceContext";
import type { CatalogDiscountRef } from "./CatalogDiscountRef";
import type { CatalogDiscountStaff } from "./CatalogDiscountStaff";
import type { CatalogItemDiscountDTOBase } from "./CatalogItemDiscountDTOBase";
import type { CatalogItemRef } from "./CatalogItemRef";
import type { CatalogItemStaff } from "./CatalogItemStaff";
import type { TrackedModernBase } from "./TrackedModernBase";

export class CatalogItemDiscountStaff implements CatalogItemDiscountDTOBase, TrackedModernBase {
  constructor(public readonly assignId: number, public readonly itemId: CatalogItemStaff | null, public readonly discountId: CatalogDiscountStaff | null, public readonly discountType: string | null, public readonly amountCents: number | null, public readonly percent: string | null, public readonly requiresParentEligibility: boolean | null, public readonly addChildItemsIfFree: boolean | null, public readonly createdOn: Date | null, public readonly createdBy: string | null, public readonly updatedOn: Date | null, public readonly updatedBy: string | null, public readonly itemIdTargetIds: CatalogItemRef, public readonly discountIdTargetIds: CatalogDiscountRef) {
    this.cbiServiceContext = null;
    this.itemIdLoaded = this.itemId != null;
    this.itemIdCached = this.itemId;
    this.discountIdLoaded = this.discountId != null;
    this.discountIdCached = this.discountId;
  }
  cbiServiceContext: CbiFrontendServiceContext | null;
  private itemIdLoaded: boolean;
  private itemIdCached: CatalogItemStaff | null;
  private discountIdLoaded: boolean;
  private discountIdCached: CatalogDiscountStaff | null;
  async itemIdLazy(): Promise<CatalogItemStaff> {
    if (!this.itemIdLoaded) {
      this.itemIdCached = await this.cbiServiceContext!.catalogService().getCatalogItemStaff(this.itemIdTargetIds.assignId);
      this.itemIdLoaded = true;
    }
    return this.itemIdCached!;
  }
  async discountIdLazy(): Promise<CatalogDiscountStaff> {
    if (!this.discountIdLoaded) {
      this.discountIdCached = await this.cbiServiceContext!.discountService().getCatalogDiscountStaff(this.discountIdTargetIds.discountId);
      this.discountIdLoaded = true;
    }
    return this.discountIdCached!;
  }
}
